import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { DoBootstrap, NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UpgradeModule } from '@angular/upgrade/static';
import { aclReducer, bigGroupListReducer } from '@acl/acl.store';
import { CoreModule } from '@core/core.module';
import {
  enterpriseReducer,
  userReducer,
  userSelfReducer,
  maskReducer,
  todoTaskReducer,
  menuReducer,
  tabkeyReducer,
  loginMethodReducer,
  VerifyModeReducer
} from '@core/store';
import { LayoutModule } from '@layout/layout.module';
import { layoutReducer } from '@layout/layout.store';
import { watermarkReducer } from '@layout/watermark/watermark.store';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { BankNameService } from '@core/service/bankName.service';
import { NZ_MODAL_DATA, NzModalModule } from 'ng-zorro-antd/modal';

import { zhCN, enUS } from 'date-fns/locale';
import { NZ_DATE_LOCALE, NZ_I18N, zh_CN, en_US } from 'ng-zorro-antd/i18n';
const LANG_PROVIDES = [
  { provide: NZ_I18N, useFactory: (localId: string) => (localId === 'en-US' ? en_US : zh_CN), deps: [LOCALE_ID] },
  { provide: NZ_DATE_LOCALE, useFactory: (localId: string) => (localId === 'en-US' ? enUS : zhCN), deps: [LOCALE_ID] }
];
// #endregion

import { MatomoModule } from 'ngx-matomo-v9';
import { NgxEchartsModule } from 'ngx-echarts';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    UpgradeModule,
    MatomoModule,
    StoreModule.forRoot({
      user: userReducer,
      userSelf: userSelfReducer,
      enterprise: enterpriseReducer,
      layout: layoutReducer,
      acl: aclReducer,
      mask: maskReducer,
      todoTask: todoTaskReducer,
      watermark: watermarkReducer,
      menu: menuReducer,
      bigGroup: bigGroupListReducer,
      tabkey: tabkeyReducer,
      loginMethod: loginMethodReducer,
      verifyMode: VerifyModeReducer
    }),
    EffectsModule.forRoot(),
    NzModalModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts') }),
    CoreModule,
    LayoutModule,
    AppRoutingModule
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: '!' },
    { provide: NZ_MODAL_DATA, useValue: {} },
    ...LANG_PROVIDES,
    BankNameService,
    {
      provide: APP_INITIALIZER,
      useFactory: (bankNameService: BankNameService) => () => {
        bankNameService.initbankNameJson();
      },
      deps: [BankNameService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule implements DoBootstrap {
  constructor(private upgrade: UpgradeModule) {}

  ngDoBootstrap() {
    this.upgrade.bootstrap(document.body, ['app'], { strictDi: true });
  }
}
